<template>
  <div
    class="env-wrapper"
    :class="getEnv === 'prod' ? 'prod-env' : 'stage-env'"
  >
    <div class="custom-button" @click="handlerSelectEnv">
      <font-awesome-icon
        icon="angle-down"
        size="sm"
        class="q-ml-sm"
        :class="selectEnv ? 'rotate-bottom' : 'rotate-top'"
      />
    </div>

    <q-slide-transition>
      <div v-show="selectEnv" class="select-env-container">
        <div
          class="select-env-content"
          :class="getEnv === 'stage' && 'active'"
          @click="handlerEnv('stage')"
        >
          STAGE
        </div>

        <q-separator />

        <div
          class="select-env-content"
          :class="getEnv === 'prod' && 'active'"
          @click="handlerEnv('prod')"
        >
          PROD
        </div>
      </div>
    </q-slide-transition>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "SelectEnv",

  data() {
    return {
      selectEnv: false,
    };
  },

  components: {},

  computed: {
    ...mapGetters({
      getEnv: "selectEnv/getEnv",
    }),
  },

  methods: {
    ...mapActions({
      setEnv: "selectEnv/setEnv",
    }),

    handlerSelectEnv() {
      this.selectEnv = !this.selectEnv;
    },

    handlerEnv(env) {
      this.setEnv(env);
      this.selectEnv = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.env-wrapper {
  font-weight: bold;
  color: $white;
  width: 70px;
  max-width: 70px !important;
}
.prod-env {
  color: #fff;
}
.stage-env {
  color: #000;
}

.custom-button {
  cursor: pointer;
  margin: 25px 0 0 0;

  .rotate-top {
    transition: all 0.3s ease;
    transform: rotate(0deg) !important;
  }

  .rotate-bottom {
    transition: all 0.3s ease;
    transform: rotate(-180deg) !important;
  }
}

.select-env-container {
  position: absolute;
  right: 0;
  color: $primary;
  margin-top: 8px;
  z-index: 6999 !important;
  width: 120px;
  background-color: $secondary;
  box-shadow: rgba(0, 0, 0, 0.19) 0px 10px 20px, rgba(0, 0, 0, 0.23) 0px 6px 6px;
  border-radius: 4px;
}

.select-env-content {
  padding: 15px 25px;
  transition: all 0.3s ease-in-out;
  cursor: pointer;
  opacity: 0.4;

  &:hover {
    letter-spacing: 1px;
    color: $red;
    opacity: 1;
  }
}

.active {
  opacity: 1;
}
</style>
